module.exports = __webpack_public_path__ + "img/pixnew.75b1676e.png";